import { Observable } from 'rxjs';
import { Product } from '@spartacus/core';

export abstract class ProductOfTheMonthAdapter {
  abstract load(): Observable<Product>;
}
